import { Component, EventEmitter, Input, Output } from '@angular/core';

import { FileData } from '../../models';

@Component({
  selector: 'app-drag-and-drop',
  templateUrl: './drag-and-drop.component.html',
  styleUrl: './drag-and-drop.component.scss',
})
export class DragAndDropComponent {
  @Input() header: string;
  @Input() text: string;
  @Input() processingText: string;
  @Input() dragAndDropClass: string;
  @Input() dragAndDropProgressClass: string;

  @Output() dropFiles = new EventEmitter<any>();

  protected processing: boolean;

  private fileEmit: FileData = {} as FileData;

  onDragOver(event: any) {
    event.preventDefault();
  }

  onDropSuccess(event: any) {
    event.preventDefault();
    if (event.dataTransfer.files.length) {
      this.emitFiles(event.dataTransfer.files[0]);
    }
  }

  private readFiles(file: File, callback: any) {
    const reader = new FileReader();
    this.readFile(file, reader, (result: any) => {
      this.fileEmit.name = file.name;
      this.fileEmit.src = result;
      callback();
    });
  }

  private readFile(file: File, reader: any, callback: any) {
    reader.onload = () => callback(reader.result);
    reader.readAsDataURL(file);
  }

  private emitFiles(file) {
    this.processing = true;
    this.readFiles(file, () => {
      this.dropFiles.emit(this.fileEmit);
    });
    this.processing = false;
  }

  onChange(event: any) {
    this.emitFiles(event.target.files[0]);
    event.target.value = '';
  }
}
